module.exports = {"id":"184484","name":"Gylfi Sigurðsson","rating":"82","photo":"./data/images/photos/1/184484.png","club":{"name":"Everton","logo":"./data/images/clubs/Everton.png"},"positions":["MG","MOC","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GylfiSigurðsson0.json
// module id = 1679
// module chunks = 0